/* istanbul ignore file */

import MuiTabPanel from '@mui/lab/TabPanel';
import { styled } from '../styles';

export type { TabPanelProps as Props } from '@mui/lab/TabPanel';

const TabPanel = styled(MuiTabPanel)(() => ({
  '&.MuiTabPanel-root': {
    padding: 0,
  },
}));

export default TabPanel;
